import React from 'react';

const Footer = () => {
  return (
    <footer className='footer-copyright' id='footer'>
      <div className='container'>&copy; 2022 Camila Barros</div>
    </footer>
  );
};

export default Footer;
